import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { modifierChecked } from "./slice";
import { patchCompte } from "./action";
import { ShoppingCart, Trash2, Plus, Minus } from "lucide-react";
import { Navbar } from "./navbar";
import "../styles/panier.css";

export function Panier() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const loggedUser = localStorage.getItem('user');
    const userEmail = loggedUser ? JSON.parse(loggedUser).email : null;
    const list = useSelector(s => s.panier) || [];

    // Safely calculate total
    const total = list.reduce((S, i) => {
        if (i.checked) {
            const val = typeof i.prix === 'string' ? parseFloat(i.prix.replace(/[^0-9.]/g, '')) : i.prix;
            return S + (isNaN(val) ? 0 : val * (i.quantite || 1));
        }
        return S;
    }, 0);

    const handleUpdateItem = (updatedItem) => {
        if (!loggedUser) return;
        const userObj = JSON.parse(loggedUser);
        const newPanier = list.map(p => p.id === updatedItem.id ? updatedItem : p);
        dispatch(patchCompte({ id: userObj.id, panier: newPanier }));
    };

    const handleDeleteItem = (id) => {
        if (!loggedUser) return;
        const userObj = JSON.parse(loggedUser);
        const newPanier = list.filter(p => p.id !== id);
        dispatch(patchCompte({ id: userObj.id, panier: newPanier }));
    };

    const handleValider = () => {
        const user = localStorage.getItem('user');
        if (!user) {
            // Optionnel: Alert or Toast
            alert("Veuillez vous connecter pour valider votre commande.");
            navigate("/login");
        } else {
            navigate("/valider");
        }
    };

    const hasCheckedItems = list.some(i => i.checked);
    const checkedCount = list.filter(i => i.checked).length;

    return (
        <div className="panier-page">
            <Navbar />

            <div className="panier-container">
                {list.length === 0 ? (
                    <div className="panier-main panier-main-empty">
                        <div className="panier-empty">
                            <span className="panier-empty-icon"><ShoppingCart size={80} color="#000033" strokeWidth={1.5} /></span>
                            <h3>Votre panier est vide</h3>
                            <p>Découvrez nos climatiseurs et ajoutez-les à votre panier.</p>
                            <Link to="/" className="btn-retour-boutique">Retour à la boutique</Link>
                        </div>
                    </div>
                ) : (
                    <>
                        <div className="panier-main">
                            <div className="panier-header">
                                <h2>Mon Panier <span className="header-count">({list.length} articles)</span></h2>
                            </div>

                            <div className="cart-items-list">
                                {list.map(a => (
                                    <div key={a.id} className={`cart-item ${a.checked ? 'checked' : ''}`}>
                                        <div className="item-checkbox" title="Sélectionner pour l'achat">
                                            <input
                                                type="checkbox"
                                                checked={a.checked}
                                                onChange={() => handleUpdateItem({ ...a, checked: !a.checked })}
                                            />
                                        </div>

                                        <Link to={`/infoClimatisseur/${a.originalId || a.id.toString().split('_')[0]}`} state={{ cartItemId: a.id, fromList: true }}>
                                            <img src={a.image} alt={a.nomClimatisseur} className="item-image" />
                                        </Link>

                                        <div className="item-details">
                                            <h4 className="item-title">{a.nomClimatisseur}</h4>
                                            <p className="item-size">Taille choisie: {a.taille}</p>
                                            {a.color && (
                                                <div className="item-color-row">
                                                    <span className="color-label">Couleur:</span>
                                                    <div
                                                        className="color-preview"
                                                        style={{ backgroundColor: a.color }}
                                                    ></div>
                                                    <span className="color-name">{a.color}</span>
                                                </div>
                                            )}
                                            <p className="item-price">{a.prix} DH</p>
                                            <div className="quantity-controls">
                                                <button
                                                    className="quantity-btn"
                                                    onClick={() => {
                                                        if (a.quantite > 1) {
                                                            handleUpdateItem({ ...a, quantite: a.quantite - 1 });
                                                        } else {
                                                            handleDeleteItem(a.id);
                                                        }
                                                    }}
                                                >
                                                    <Minus className="icon-qty" />
                                                </button>
                                                <span className="quantity-num">{a.quantite || 1}</span>
                                                <button
                                                    className="quantity-btn"
                                                    onClick={() => handleUpdateItem({ ...a, quantite: (a.quantite || 1) + 1 })}
                                                >
                                                    <Plus className="icon-qty" />
                                                </button>
                                            </div>
                                        </div>

                                        <button
                                            className="btn-delete-item"
                                            onClick={() => handleDeleteItem(a.id)}
                                            title="Supprimer l'article"
                                        >
                                            <Trash2 className="icon-delete" />
                                        </button>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="panier-summary">
                            <h3 className="summary-title">Résumé de la commande</h3>

                            <div className="summary-body">
                                <div className="summary-left">
                                    <div className="summary-row">
                                        <span>Articles sélectionnés</span>
                                        <span>{checkedCount}</span>
                                    </div>
                                    <div className="summary-row">
                                        <span>Frais de livraison</span>
                                        <span className="delivery-free">Gratuit</span>
                                    </div>
                                </div>

                                <div className="summary-right">
                                    <div className="summary-total">
                                        <span>Total</span>
                                        <span className="total-amount">{total.toLocaleString()} DH</span>
                                    </div>

                                    <button
                                        className="btn-valider"
                                        disabled={!hasCheckedItems}
                                        onClick={handleValider}
                                    >
                                        Valider la commande
                                    </button>

                                    {!hasCheckedItems && (
                                        <p className="validation-msg">
                                            Veuillez sélectionner au moins un article.
                                        </p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}
